var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradientCreateArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05293 19.6562C1.90694 19.6562 1.76272 19.6242 1.6304 19.5625C1.49809 19.5008 1.38088 19.4108 1.287 19.299C1.19313 19.1872 1.12486 19.0562 1.08698 18.9152C1.04911 18.7742 1.04256 18.6266 1.06777 18.4828L1.79512 14.3609C1.83057 14.1596 1.92698 13.974 2.07129 13.8293L12.4006 3.50039C12.4563 3.44466 12.5224 3.40045 12.5952 3.37029C12.668 3.34013 12.746 3.32461 12.8248 3.32461C12.9036 3.32461 12.9816 3.34013 13.0544 3.37029C13.1272 3.40045 13.1933 3.44466 13.249 3.50039L17.2088 7.46016C17.2645 7.51586 17.3087 7.58199 17.3389 7.65478C17.369 7.72757 17.3846 7.80558 17.3846 7.88437C17.3846 7.96316 17.369 8.04118 17.3389 8.11397C17.3087 8.18676 17.2645 8.25289 17.2088 8.30859L6.88145 18.6359C6.73653 18.7814 6.55012 18.8784 6.34785 18.9137L2.22675 19.641C2.16936 19.6511 2.1112 19.6562 2.05293 19.6562ZM2.96621 14.6316L2.2994 18.4094L6.07792 17.7426L15.9361 7.88437L12.8248 4.77304L2.96621 14.6316Z",
    fill: "url(#paint0_linear_121_1062)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7844 8.48438C16.7056 8.48448 16.6275 8.469 16.5547 8.43883C16.4819 8.40866 16.4158 8.3644 16.3602 8.3086L12.4004 4.34881C12.3447 4.29311 12.3005 4.22697 12.2703 4.15418C12.2401 4.08139 12.2246 4.00338 12.2246 3.92459C12.2246 3.84579 12.2401 3.76778 12.2703 3.69499C12.3005 3.6222 12.3447 3.55606 12.4004 3.50037L14.9461 0.954661C15.2889 0.62728 15.7447 0.444603 16.2188 0.444603C16.6928 0.444603 17.1486 0.62728 17.4914 0.954661L19.7543 3.21761C20.0912 3.55544 20.2804 4.01306 20.2805 4.49018C20.2806 4.9673 20.0915 5.42498 19.7547 5.76292L17.2086 8.30862C17.1529 8.36442 17.0868 8.40868 17.014 8.43884C16.9412 8.469 16.8632 8.48448 16.7844 8.48438ZM13.673 3.92461L16.7844 7.03594L18.9059 4.91446C19.0181 4.80179 19.0811 4.64925 19.0811 4.49024C19.0811 4.33123 19.0181 4.17869 18.9059 4.06602L16.643 1.80313C16.5287 1.69407 16.3769 1.63321 16.2189 1.63321C16.061 1.63321 15.9091 1.69407 15.7949 1.80313L13.673 3.92461Z",
    fill: "url(#paint1_linear_121_1062)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0003 22H1.40029C1.24116 22 1.08855 21.9368 0.976029 21.8243C0.863507 21.7117 0.800293 21.5591 0.800293 21.4C0.800293 21.2409 0.863507 21.0883 0.976029 20.9757C1.08855 20.8632 1.24116 20.8 1.40029 20.8H19.0003C19.1594 20.8 19.312 20.8632 19.4246 20.9757C19.5371 21.0883 19.6003 21.2409 19.6003 21.4C19.6003 21.5591 19.5371 21.7117 19.4246 21.8243C19.312 21.9368 19.1594 22 19.0003 22Z",
    fill: "url(#paint2_linear_121_1062)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2001 4.4C2.04098 4.39996 1.88839 4.33673 1.77588 4.22422C1.66337 4.1117 1.60014 3.95912 1.6001 3.8V0.6C1.6001 0.44087 1.66331 0.288258 1.77583 0.175736C1.88836 0.063214 2.04097 0 2.2001 0C2.35923 0 2.51184 0.063214 2.62436 0.175736C2.73688 0.288258 2.8001 0.44087 2.8001 0.6V3.8C2.80006 3.95912 2.73683 4.1117 2.62431 4.22422C2.5118 4.33673 2.35921 4.39996 2.2001 4.4Z",
    fill: "url(#paint3_linear_121_1062)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8 2.8H0.6C0.44087 2.8 0.288258 2.73678 0.175736 2.62426C0.063214 2.51174 0 2.35913 0 2.2C0 2.04087 0.063214 1.88826 0.175736 1.77573C0.288258 1.66321 0.44087 1.6 0.6 1.6H3.8C3.95913 1.6 4.11174 1.66321 4.22426 1.77573C4.33679 1.88826 4.4 2.04087 4.4 2.2C4.4 2.35913 4.33679 2.51174 4.22426 2.62426C4.11174 2.73678 3.95913 2.8 3.8 2.8Z",
    fill: "url(#paint4_linear_121_1062)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8002 6C7.64108 5.99996 7.48849 5.93673 7.37598 5.82422C7.26347 5.7117 7.20024 5.55912 7.2002 5.4V2.2C7.2002 2.04087 7.26341 1.88826 7.37593 1.77573C7.48845 1.66321 7.64107 1.6 7.8002 1.6C7.95933 1.6 8.11194 1.66321 8.22446 1.77573C8.33698 1.88826 8.4002 2.04087 8.4002 2.2V5.4C8.40015 5.55912 8.33693 5.7117 8.22441 5.82422C8.1119 5.93673 7.95931 5.99996 7.8002 6Z",
    fill: "url(#paint5_linear_121_1062)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4001 4.4H6.2001C6.04097 4.4 5.88836 4.33679 5.77583 4.22427C5.66331 4.11175 5.6001 3.95913 5.6001 3.8C5.6001 3.64087 5.66331 3.48826 5.77583 3.37574C5.88836 3.26322 6.04097 3.2 6.2001 3.2H9.4001C9.55923 3.2 9.71184 3.26322 9.82436 3.37574C9.93688 3.48826 10.0001 3.64087 10.0001 3.8C10.0001 3.95913 9.93688 4.11175 9.82436 4.22427C9.71184 4.33679 9.55923 4.4 9.4001 4.4Z",
    fill: "url(#paint6_linear_121_1062)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8002 19.6C15.6411 19.6 15.4885 19.5367 15.376 19.4242C15.2635 19.3117 15.2002 19.1591 15.2002 19V15.8C15.2002 15.6409 15.2634 15.4883 15.3759 15.3757C15.4885 15.2632 15.6411 15.2 15.8002 15.2C15.9593 15.2 16.1119 15.2632 16.2245 15.3757C16.337 15.4883 16.4002 15.6409 16.4002 15.8V19C16.4002 19.1591 16.3369 19.3117 16.2244 19.4242C16.1119 19.5367 15.9593 19.6 15.8002 19.6Z",
    fill: "url(#paint7_linear_121_1062)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3996 18H14.1996C14.0405 18 13.8879 17.9368 13.7753 17.8243C13.6628 17.7117 13.5996 17.5591 13.5996 17.4C13.5996 17.2409 13.6628 17.0883 13.7753 16.9757C13.8879 16.8632 14.0405 16.8 14.1996 16.8H17.3996C17.5587 16.8 17.7114 16.8632 17.8239 16.9757C17.9364 17.0883 17.9996 17.2409 17.9996 17.4C17.9996 17.5591 17.9364 17.7117 17.8239 17.8243C17.7114 17.9368 17.5587 18 17.3996 18Z",
    fill: "url(#paint8_linear_121_1062)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8002 14.8C19.6411 14.7999 19.4885 14.7367 19.376 14.6242C19.2635 14.5117 19.2002 14.3591 19.2002 14.2V11C19.2002 10.8409 19.2634 10.6882 19.3759 10.5757C19.4885 10.4632 19.6411 10.4 19.8002 10.4C19.9593 10.4 20.1119 10.4632 20.2245 10.5757C20.337 10.6882 20.4002 10.8409 20.4002 11V14.2C20.4002 14.3591 20.3369 14.5117 20.2244 14.6242C20.1119 14.7367 19.9593 14.7999 19.8002 14.8Z",
    fill: "url(#paint9_linear_121_1062)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4001 13.2H18.2001C18.041 13.2 17.8884 13.1368 17.7758 13.0243C17.6633 12.9117 17.6001 12.7591 17.6001 12.6C17.6001 12.4409 17.6633 12.2883 17.7758 12.1757C17.8884 12.0632 18.041 12 18.2001 12H21.4001C21.5592 12 21.7118 12.0632 21.8244 12.1757C21.9369 12.2883 22.0001 12.4409 22.0001 12.6C22.0001 12.7591 21.9369 12.9117 21.8244 13.0243C21.7118 13.1368 21.5592 13.2 21.4001 13.2Z",
    fill: "url(#paint10_linear_121_1062)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_121_1062",
    x1: 9.21865,
    y1: 3.32461,
    x2: 9.21865,
    y2: 19.6562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_121_1062",
    x1: 16.2526,
    y1: 0.444603,
    x2: 16.2526,
    y2: 8.48438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_121_1062",
    x1: 10.2003,
    y1: 20.8,
    x2: 10.2003,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_121_1062",
    x1: 2.2001,
    y1: 0,
    x2: 2.2001,
    y2: 4.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_121_1062",
    x1: 2.2,
    y1: 1.6,
    x2: 2.2,
    y2: 2.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_121_1062",
    x1: 7.8002,
    y1: 1.6,
    x2: 7.8002,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_121_1062",
    x1: 7.8001,
    y1: 3.2,
    x2: 7.8001,
    y2: 4.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_121_1062",
    x1: 15.8002,
    y1: 15.2,
    x2: 15.8002,
    y2: 19.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_121_1062",
    x1: 15.7996,
    y1: 16.8,
    x2: 15.7996,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_121_1062",
    x1: 19.8002,
    y1: 10.4,
    x2: 19.8002,
    y2: 14.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_121_1062",
    x1: 19.8001,
    y1: 12,
    x2: 19.8001,
    y2: 13.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD00AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7064E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientCreateArt);
export default __webpack_public_path__ + "static/media/gradientCreateArt.98037a897d7026a6c4c0e1eaeaf7abb8.svg";
export { ForwardRef as ReactComponent };